export default (state, action) => {
  switch (action.type) {
    case "ADD_DEVICE_DEVICE":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          name: action.device.name,
          serial_number: action.device.serial_number,
        },
      };
    case "ADD_DEVICE_CATEGORY":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          category: action.device.category,
          type: action.device.type,
        },
      };
    case "ADD_DEVICE_TAG_CAT":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          tag_cat: action.device.tag_cat,
        },
      };
    case "ADD_DEVICE_TAG":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          tags: action.device.tags,
        },
      };
    case "ADD_ROLE_INFO":
      // do something
      return {
        ...state,
        role: {
          ...state.role,
          name: action.role.name,
          description: action.role.description,
          permissions: action.role.permissions,
        },
      };
    case "ADD_ROLE_ACCESS":
      // do something
      return {
        ...state,
        role: {
          ...state.role,
          navs: action.role.navs,
          navsObj: action.role.navsObj,
          descendant: action.role.descendant,
        },
      };
    case "EDIT_ROLE_DIRECT":
      // do something
      return {
        ...state,
        role: {
          ...state.role,
          direct: action.role.direct,
        },
      };
    case "ADD_ROLE":
      // do something
      return {
        ...state,
        role: action.role,
      };
    case "SET_APP_NAME":
      // do something
      return {
        ...state,
        application: {
          ...state.application,
          title: action.application.title,
        },
      };
    case "ADD_DEVICE_CONFIG":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          sensors: action.device.sensors,
        },
      };
    case "ADD_DEVICE_LORA":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          dev_eui: action.device.dev_eui,
          otaa_key: action.device.otaa_key,
          network_server_id: action.device.network_server_id,
        },
      };
    case "ADD_DEVICE_ZLAN":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          dev_uid: action.device.dev_uid,
        },
      };
    case "ADD_DEVICE_USRIOT":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          dev_uid: action.device.dev_uid,
        },
      };
    case "ADD_DEVICE_BIVOCOM":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          dev_uid: action.device.dev_uid,
        },
      };
    case "ADD_DEVICE_FRIENDCOM":
      // do something
      return {
        ...state,
        device: {
          ...state.device,
          dev_uid: action.device.dev_uid,
        },
      };
    case "SET_DEVICE_EMPTY":
      // do something
      return {
        ...state,
        device: {},
      };
    case "SET_ROLE_EMPTY":
      // do something
      return {
        ...state,
        role: {},
      };
    case "SET_KEY_DATE":
      // do something
      return {
        ...state,
        key: {
          ...state.key,
          date: action.key.date,
        },
      };
    case "SET_KEY_DATE_EMPTY":
      // do something
      return {
        ...state,
        key: {},
      };
    default:
      // do something
      return state;
  }
};
